import React from 'react'
import { func, string, arrayOf, shape } from 'prop-types'
import { Controller } from 'react-hook-form'

import AutoComplete from './InputAutocomplete.style'

export default function InputAutocomplete({
  control,
  name,
  label,
  options,
  onChange,
  onSelect,
  onKeyPress,
}) {
  return (
    <Controller
      full
      cleanable={false}
      as={AutoComplete}
      name={name}
      control={control}
      label={label}
      options={options}
      onChange={onChange}
      onSelect={onSelect}
      onKeyPress={onKeyPress}
    />
  )
}

InputAutocomplete.propTypes = {
  control: shape().isRequired,
  name: string.isRequired,
  label: string,
  options: arrayOf(string).isRequired,
  onChange: func.isRequired,
  onSelect: func.isRequired,
  onKeyPress: func,
}

InputAutocomplete.defaultProps = {
  label: '',
  onKeyPress: () => {},
}
